<template>
  <div class="card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CardContainer'
}
</script>

<style scoped>
.card {
  max-height: 85vh;
  overflow: auto;
  height: fit-content;
  width: 600px;
  background: #fff;
  border-radius: 16px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
}
</style>
